import React, {Component} from 'react';
import {APIClient} from "../../../utils/APIClient";
import {URLQueryStringParser} from "../../../utils/URLQueryStringParser";
import {API_URL, APP_URL, SHOPIFY_REDIRECT_URL, SHOPIFY_NONCE} from '../../../settings/local_settings';
import {Loading} from "../../Loading";


import {withRouterParams} from "../../../utils/withRouterParams";

class ConnectShopify extends Component {
    static apiCallInProgress = false;

    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    _getAuthURL(shop) {
        // Extraer el subdominio del shop (ej: "xbbf0y-vp.myshopify.com" -> "xbbf0y-vp")
        const store_subdomain = shop ? shop.split('.')[0] : '';
        const redirect_uri = encodeURIComponent(APP_URL + "connect-shopify");
        const url = SHOPIFY_REDIRECT_URL.replace('{{store_subdomain}}', store_subdomain).replace('{{redirect_uri}}', redirect_uri);
        return url;
    }

    componentDidMount() {
        if (ConnectShopify.apiCallInProgress) {
            return;
        }
        ConnectShopify.apiCallInProgress = true;

        // La URL tiene el siguiente formato:
        // https://app.dashbo.io/connect-shopify?code=XXX&hmac=XXX&host=XXX&shop=XXX.myshopify.com&state=slñkfdjklksdjflksd_&timestamp=XXX
        // O durante la instalación inicial (sin code):
        // https://app.dashbo.io/connect-shopify?hmac=XXX&host=XXX&shop=XXX.myshopify.com&timestamp=XXX

        // El código es el que se obtiene después de que el usuario da permisos a la tienda para que se pueda conectar.
        // El hmac es una firma digital que Shopify genera para verificar que la petición es originada de Shopify.
        // El host es el dominio de la tienda (base64_encoded_hostname).
        // El shop es el subdominio de la tienda.
        // El state es un identificador único para la conexión.
        // El timestamp es el tiempo en el que se generó la petición.
        const urlParse = new URLQueryStringParser();
        let authorization_code = urlParse.getUrlParams('code');
        let hmac = urlParse.getUrlParams('hmac');
        let shop = urlParse.getUrlParams('shop');
        let state = urlParse.getUrlParams('state');

        // Si no hay código de autorización, significa que es la instalación inicial
        // y debemos redirigir inmediatamente a la URL de autorización de Shopify
        if (!authorization_code && shop) {
            const authUrl = this._getAuthURL(shop);
            window.location.href = authUrl;
            return;
        }
 
        // Si hay código, procesamos el callback de OAuth
        new APIClient(API_URL + 'get_access_tokens/shopify/').call('POST', {'authorization_code': authorization_code, 'shop': shop, 'hmac': hmac, 'state': state}).then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
                this.props.history.push('/agency/conections');
            } else if (data.status === 'OK') {
                this.props.history.push('/agency/conections');
                alert('La tienda de Shopify fue vinculada con éxito!')
            }
        }).finally(() => {
            ConnectShopify.apiCallInProgress = false;
        });
    }

    render() {
        return <Loading message="Por favor espere mientras se conecta la tienda."/>
    }
}

export default withRouterParams(ConnectShopify);
